exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#subNav[data-v-542945fc]{width:980px}", ""]);

// exports
